function LaporanKeuangan() {
    return (
        <>
            <article className="table-keuangan-ojk float-left" style={{ width: '99%' }}>
                <div className="general-container" style={{ backgroundColor: 'white', marginTop: '-1%' }}>
                    <div className="grid grid-cols-2">
                        <div className="table-ojk">
                            <div style={{ marginBottom: '2%' }}>
                                <p style={{ fontSize: '16px' }}><strong style={{ fontSize: '20px' }}>Laporan Posisi Keuangan Tahun 2024</strong>
                                    <br />
                                    <span className="blue-line" />
                                </p>
                            </div>
                            <div>
                                <table>
                                    <tr className="border-none">
                                        <th colspan="2"><strong>Aset</strong></th>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title">Aset Lancar</td>
                                        <td className="value"> 11.472.185.245</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title">Aset Tidak Lancar</td>
                                        <td className="value">1.206.913.173</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title"><strong>Total Aset</strong></td>
                                        <td className="value"><strong>12.679.098.418</strong></td>
                                    </tr>

                                    <tr className="border-none">
                                        <td colspan="2"></td>
                                    </tr>

                                    <tr className="border-none">
                                        <th colspan="2"><strong>Kewajiban</strong></th>
                                    </tr>

                                    <tr className="border-bottom">
                                        <td className="title">Kewajiban Lancar</td>
                                        <td className="value">1.191.536.162</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title">Kewajiban Tidak Lancar</td>
                                        <td className="value">708.178.324</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title"><strong>Total Kewajiban</strong></td>
                                        <td className="value"><strong>1.899.714.486</strong></td>
                                    </tr>

                                    <tr className="border-none">
                                        <td colspan="2" style={{ paddingTop: '40px' }}></td>
                                    </tr>

                                    <tr className="border-none">
                                        <th className="title"><strong>Ekuitas</strong></th>
                                        <th className="value"><strong>10.779.383.932</strong></th>
                                    </tr>

                                    <tr className="border-none">
                                        <td colspan="2"></td>
                                    </tr>
                                </table>
                            </div>
                        </div>

                        <div className="table-ojk">
                            <div style={{ marginBottom: '2%' }}>
                                <p style={{ fontSize: '16px' }}><strong style={{ fontSize: '20px' }}>Laporan Laba Rugi Komprehensif Tahun 2024</strong>
                                    <br />
                                    <span className="blue-line" />
                                </p>
                            </div>
                            <div>
                                <table>
                                    <tr className="border-none">
                                        <th colspan="2" style={{ padding: '9px' }}></th>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title">Pendapatan</td>
                                        <td className="value">18.384.307.185</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title">Beban Operasional</td>
                                        <td className="value">18.037.412.307</td>
                                    </tr>
                                    <tr className="border-bottom">
                                        <td className="title">Laba Komprehensif</td>
                                        <td className="value">346.894.878</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>

                    <div className="table-ojk" style={{ width: '99%', paddingLeft: '3%' }}>
                        <table>
                            <tr className="border-none">
                                <td colspan="2"></td>
                            </tr>

                            <tr className="border-none">
                                <td colspan="2" style={{ padding: '0px 0px 5px' }}><strong style={{ fontSize: '20px' }}>Opini Audit 2024</strong></td>
                            </tr>

                            <tr className="border-none">
                                <td colspan="2" style={{ padding: '5px 0px' }}>Wajar tanpa pengecualian</td>
                            </tr>
                        </table>
                    </div>
                </div>
            </article>
            <div className="float-left w-full"></div>
        </>
    );
}

export default LaporanKeuangan;
